import React from 'react';
import { Button, Col, Form, Input, Row } from 'antd';
import { MailOutlined, UserOutlined } from '@ant-design/icons';

import ImageComponent from '@sharedComponent/image-component';
import { images } from '@assets/img';
import './crmadminaccept.scss';
import './crmadminaccept.scss';
import AppLoader from '@sharedComponent/loaders/app-loader';
import { appConstant } from '@constants';

const layout = {
	labelCol: { span: 24 },
	wrapperCol: { span: 24 },
};

const CrmAdminAcceptPresentational = ({
	isApproving,
	isRejecting,
	response,
	userDetails: { email, accessLevel },
	crmLoading,
	handleReject,
	handleApprove,
}) => {
	const [formRef] = Form.useForm();
	formRef.setFieldsValue({
		email,
		accessLevel,
	});
	return (
		<>
			{crmLoading ? (
				<AppLoader />
			) : (
				<>
					<ImageComponent className="verify_back" src={images.fullscreen} />
					<Col className="center_area">
						<Col className="body">
							<ImageComponent className="logo" src={images.logo_sm} />
							<Col className="head">User Request Permission</Col>
							{response === appConstant.success ? (
								<Col className="content"> Request permission status sent to {email}</Col>
							) : (
								<>
									<Col>
										<Col className="content"> Are you sure you want the accept the user access request ?</Col>
										<Col>
											<Form form={formRef} {...layout}>
												<Row className="crmadmin">
													<Col xl={11} lg={{ span: 11 }} md={{ span: 24 }} sm={{ span: 24 }} xs={24}>
														<Form.Item className="crmadmin" name="email" label="E-mail address">
															<Input type="email" disabled prefix={<MailOutlined />} />
														</Form.Item>
													</Col>

													<Col xl={2} lg={{ span: 2 }} md={{ span: 24 }} sm={{ span: 24 }}></Col>
													<Col xl={11} lg={{ span: 11 }} md={{ span: 24 }} sm={{ span: 24 }} xs={24}>
														<Form.Item
															validateTrigger={['onBlur']}
															className="noreq"
															name="accessLevel"
															label="Access Level">
															<Input type="text" disabled prefix={<UserOutlined />} />
														</Form.Item>
													</Col>
												</Row>
											</Form>
										</Col>
									</Col>
									<Col className="btn_area">
										<Col className="" style={{ display: 'flex', justifyContent: 'space-between' }}>
											<Button
												className="k_btn wd-200"
												style={{ marginRight: '5px' }}
												onClick={handleReject}
												loading={isRejecting}>
												Reject
											</Button>
											<Col> </Col>
											<Button
												className="k_btn wd-200"
												style={{ marginLeft: '5px' }}
												onClick={handleApprove}
												loading={isApproving}>
												Accept
											</Button>
										</Col>
									</Col>
								</>
							)}
						</Col>
					</Col>
				</>
			)}
		</>
	);
};

export default CrmAdminAcceptPresentational;
